export function setupScrollIndicator() {
    const navContainer = document.querySelector(".tour__navigation");
    if (!navContainer) return;
  
    const navList = navContainer.querySelector("ol");
    const scrollIndicator = navContainer.querySelector(".tour__navigation__scroll-indicator");
  
    function updateIndicator() {
      if (navList.scrollWidth > navContainer.clientWidth) {
        scrollIndicator.style.opacity = "1";
      } else {
        scrollIndicator.style.opacity = "0";
      }
    }
  
    updateIndicator();
  
    window.addEventListener("resize", updateIndicator);
    navList.addEventListener("scroll", function () {
      if (navList.scrollLeft + navContainer.clientWidth < navList.scrollWidth) {
        scrollIndicator.style.opacity = "1";
      } else {
        scrollIndicator.style.opacity = "0";
      }
    });
  }
  